type QueryParams = Record<string, string | number | undefined>;

/** Encodes a flat parameter bag, omitting absent values. */
export const buildQuery = (params: QueryParams): string => {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') query.set(key, String(value));
  }
  const encoded = query.toString();
  return encoded ? `?${encoded}` : '';
};
